import React, {useEffect, useRef, useState} from "react";

import {toast} from "react-toastify";
import logo from './img/brand/logo.png';
import btc from './img/coins/btc.svg';
import eth from './img/coins/eth.svg';
import usdt from './img/coins/usdt.svg';
import doge from './img/coins/doge.svg';
import trx from './img/coins/trx.svg';
import {NavLink, useParams} from "react-router-dom";

const DataContext = React.createContext();


export const Context = (props) => {

    const toastID = useRef(0)
    const [auth , setAuth] = useState(localStorage.getItem('auth-ex'))
    const [profile , setProfile] = useState(null)
    const btn= {
        BTC:btc,
        ETH:eth,
        USDT:usdt,
        DOGE:doge,
        TRX:trx,
    }
    const [trs, setTrs] = useState([

    ])

    async function ajax(url, params = {}, header = {"content-type": "application/x-www-form-urlencoded"}, method = 'POST') {

        const response = await fetch(url, {
            method: method,
            headers: header,
            body: Object.keys(params).map(key => key + '=' + params[key]).join('&')
        });
        try {
            var res = await response.json();
            if (res === undefined) return false;
            if (res.status === 'error' && res.message === 2000) {
                localStorage.clear()
                setAuth(null)
            }

            return res;
        } catch (e) {
            return false;
        }

    }

    function _notif(m, msg, timer = 5000) {


        try {

            toast.dismiss('s' + toastID.current);
            toastID.current++;
            setTimeout(function () {
                toast(msg, {
                    toastId: 's' + toastID.current,
                    position: "top-center",
                    hideProgressBar: false,
                    autoClose: timer,
                    className: m === 'error' ? 'bg-danger text-white' : m === 'info' ? 'bg-info text-white' : 'bg-success text-white'
                });
            }, 200)
        } catch (e) {
        }
    }





    function addCommos(event, nm = '') {

        if (event === '-') return '-';
        var nStr = event + "";
        var x = nStr.split(".");
        var x1 = x[0];
        var x2 = x.length > 1 ? "." + x[1] : "";
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, "$1" + "," + "$2");
        }
        var ret = x1 + x2.slice(0, 3);
        if (ret.toString() === 'NaN') ret = '';
        return ret;
    }
    function removeCommos(event) {
        if (event === '-') return '-';
        return event.replace(/,/g, '');
    }


    useEffect(function () {

        ajax(window.config.api+'/home/products' , {}).then(function (res) {

            var list = [];
            res && res.forEach(function (v) {
                list.push(
                    {
                        alt: 'خرید و فروش  '+ v.title,
                        name: v.title,
                        en: v.code,
                        percent: '0',
                        sell: v.sell,
                        buy:  v.buy,
                        logo: btn[v.code]
                    }

                )


            })

            setTrs(list)
        })
    }, [])
    useEffect(function () {

        if(auth !== null){
            ajax(window.config.api+'/profile/dashboard' ,  {
                authToken:auth,
            }).then(function (res) {
                setProfile(res)

            })
        }

    }, [auth])

    return <DataContext.Provider value={
        {

            _notif:_notif,
            logo:logo,
            NavLink:NavLink,
            useParams:useParams,
            ajax:ajax,
            addCommos:addCommos,
            removeCommos:removeCommos,
            auth:auth,
            setAuth:setAuth,
            profile:profile,
            setProfile:setProfile,
            btn:btn,
            trs:trs,
            setTrs:setTrs,


        }
    }>{props.children}</DataContext.Provider>


}

export default DataContext;
